module.exports = __webpack_public_path__ + "img/header-weddingRingsExclusive.b189808.jpg";